import { parseHtml } from "@/utils/common";

interface Condition {
  id: string | number;
  title: string;
  description: string;
}

interface UseCasePostConditionsProps {
  block: {
    title: string;
    Conditions?: Condition[];
  };
}

const UseCasePostConditions: React.FC<UseCasePostConditionsProps> = ({
  block,
}) => {
  return (
    <>
      <section className="pb-[36px] lg:pb-[46px] xl:pb-[56px] bg-white max-w-[1020px] mx-auto">
        <div className="container">
          <div className="use-case-new">
            <h2>{block.title ?? ""}</h2>
            <ul className="pl-[20px]">
              {block?.Conditions?.map((condition, index) => (
                <li
                  key={condition.id || index}
                  className="mb-[24px] relative before:content-[''] before:w-[8px] before:h-[8px] before:bg-[#7EAB00] before:absolute before:top-[7px] before:left-[-16px]"
                >
                  <h6 className="font-bold text-primary-text text-subtitle-1 mb-[12px]">
                    {condition.title}
                  </h6>
                  <p className="font-regular text-subtitle-2 text-primary-text !mb-[0]">
                    {condition.description ? parseHtml(condition.description) : ""}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default UseCasePostConditions;
